module.exports = __webpack_public_path__ + "static/fshq_team_with_bootstrap-1dd834de11ff2787e30274cd8b558c56.png";